import { Link } from "react-router-dom";
import Logo from '../asset/logos.png';
import IMG from '../asset/testtttttt.png';
import '../css/ItemBrand.css'

function ItemBrand() {
  return (
    <div>
        <div className="purchase-nav">
        <Link to="/biztransport">
          <img src={Logo} alt="Logo" style={{ width: "140px", padding:"10px 0px", paddingLeft:"14px"}} />
        </Link>
        <ul className="transport-ul">
        <li style={{ display: "inline-block" }}>
        </li>
        <li style={{ display: "inline-block", marginLeft: "9rem" }}>
        </li>
        <li style={{ display: "inline-block", marginLeft: "9rem" }}>
        </li>
        <li style={{ display: "inline-block", marginLeft: "9rem" }}>
        </li>

        <a href="https://www.jungdari.com/member/register.do"
          target="_blank"
          rel="noopener noreferrer">
        <li className="transport-signup">
          중달이닷컴 회원가입
        </li>
        </a>
        </ul>
        </div>

        <div className='notice'>
            <div className='noticecontents'>
            <div className='notictitle'>
                <img src={IMG} />
            </div>
            </div>
        </div>
    </div>
  );
}

export default ItemBrand;
